// extracted by mini-css-extract-plugin
module.exports = {"News":"News_News__3_r11","wrapper":"News_wrapper__28XHy","title":"News_title__827bR","Card":"News_Card__20Am4","content":"News_content__2yG9K","cardImage":"News_cardImage__1Rn8Z"};